export default __webpack_public_path__ + "static/media/connect.587da5a6.svg";